import { data as routerData, redirect, useLoaderData } from 'react-router';
import type { LoaderFunctionArgs } from '~/types/route-args';

import { isProfessionalRevampActive } from '@modules/professional/util/is-professional-revamp-active.server';
import { professionalTabBaseForRequest } from '@modules/professional/util/professional-tab-base';
import { loadDownloadGroups } from '@modules/professional/page/loaders/downloads-page-loader.server';
import { getSession } from '~/modules/root/util/session.server';
import { ProfessionalDownloadsPageRevamp } from '~/ui-rocco/pages/professional-detail/ProfessionalDownloadsPageRevamp';
import { DOWNLOADS_GROUND_COLOUR } from '~/ui-rocco/pages/professional-detail/sections/downloads/downloads-ground';
import type { APHandle } from '~/modules/root';
import { shouldRevalidateLeaf } from '~/modules/root/util/should-revalidate-leaf';

/**
 * The Downloads tab only exists in the revamp (legacy surfaces downloads as an
 * overview section), so when the revamp is off we send visitors to the
 * professional home rather than 404.
 */
export const loader = async (args: LoaderFunctionArgs) => {
    if (!isProfessionalRevampActive(args.context, args.request)) {
        // Back to whichever tree asked — the Business Manager preview serves
        // this same route, and a hardcoded public path would navigate the
        // preview iframe out onto the live site.
        return redirect(
            professionalTabBaseForRequest(
                args.params.urlSegment ?? '',
                args.request,
            ),
        );
    }

    const [downloads, session] = await Promise.all([
        loadDownloadGroups(args),
        getSession(args.request),
    ]);
    return routerData(downloads, { headers: await session.getHeaders() });
};

export const shouldRevalidate = shouldRevalidateLeaf;

export const handle: APHandle = {
    professionalRevampLayout: true,
    professionalGround: DOWNLOADS_GROUND_COLOUR,
};

export default function ProfessionalDownloadsRoute() {
    const data = useLoaderData<typeof loader>();
    return <ProfessionalDownloadsPageRevamp {...data} />;
}
